const TRIP_MODIFY_REASONS = [
  {
    value: "Client - Changed or Canceled Trip",
    isAvailableForEdit: true,
    isAvailableForCancel: true,
    notesRequired: true,
  },
  {
    value: "Operational - Approved Tail Change",
    isAvailableForEdit: true,
    isAvailableForCancel: false,
    notesRequired: false,
  },
  {
    value: "Client - Ghost/Non-Compliant",
    isAvailableForEdit: false,
    isAvailableForCancel: true,
    notesRequired: true,
  },
  {
    value: "Owner - Mechanical Issue",
    isAvailableForEdit: true,
    isAvailableForCancel: true,
    notesRequired: false,
  },
  {
    value: "Owner - Plane No Longer Available",
    isAvailableForEdit: true,
    isAvailableForCancel: true,
    notesRequired: false,
  },
  {
    value: "Owner - Pulled Plane (after Evo booked it)",
    isAvailableForEdit: true,
    isAvailableForCancel: true,
    notesRequired: false,
  },
  {
    value: "Owner - Owner Denied Booking",
    isAvailableForEdit: true,
    isAvailableForCancel: true,
    notesRequired: false,
  },
  {
    value: "Owner - Crew/Ops Issue (Operator's fault)",
    isAvailableForEdit: true,
    isAvailableForCancel: true,
    notesRequired: false,
  },
  {
    value: "Owner - Other (legitimate)",
    isAvailableForEdit: true,
    isAvailableForCancel: true,
    notesRequired: true,
  },
  {
    value: "Owner - Shenanigans",
    isAvailableForEdit: true,
    isAvailableForCancel: true,
    notesRequired: false,
  },
  {
    value: "Owner - Bad Press/Similar New Info",
    isAvailableForEdit: false,
    isAvailableForCancel: true,
    notesRequired: false,
  },
  {
    value: "Evo - Found Better Aircraft",
    isAvailableForEdit: false,
    isAvailableForCancel: true,
    notesRequired: false,
  },
  {
    value: "Evo - Clerical/Internal Error",
    isAvailableForEdit: true,
    isAvailableForCancel: true,
    notesRequired: false,
  },
  {
    value: "Weather",
    isAvailableForEdit: true,
    isAvailableForCancel: true,
    notesRequired: false,
  },
  {
    value: "Other Logistical",
    isAvailableForEdit: true,
    isAvailableForCancel: true,
    notesRequired: true,
  },
];

const TRIP_EDIT_REASON_OPTIONS = TRIP_MODIFY_REASONS.filter(({ isAvailableForEdit }) => isAvailableForEdit).map(({ value }) => ({
  value,
  label: value,
}));

const TRIP_CANCEL_REASON_OPTIONS = TRIP_MODIFY_REASONS.filter(({ isAvailableForCancel }) => isAvailableForCancel).map(({ value, notesRequired }) => ({
  value,
  label: value,
  notesRequired,
}));

export { TRIP_EDIT_REASON_OPTIONS, TRIP_CANCEL_REASON_OPTIONS };